import useMobile from "customHooks/useMobile";
import dayjs from "dayjs";
import { memo } from "react";
import useFormatNumbers from "../../customHooks/useFormatNumbers";
import StarsSkeleton from "../StarsSkeleton";

type donationProp =
  | "receipt_id"
  | "payout_id"
  | "amount"
  | "short_name"
  | "name"
  | "email"
  | "received_at";
type Props = {
  donation?: any;
  onDonationCardClick?: (donation: any) => void;
  selectedItems: donationProp[];
};

const DonationDetailsCard = ({
  donation,
  onDonationCardClick,
  selectedItems,
}: Props) => {
  const { formatNumbers } = useFormatNumbers();
  const isOdd = selectedItems.length % 2 !== 0;
  const colClassBuilder = isOdd ? `col-md-2 col-4` : `col-md-2 col-6`;
  const isMobile = useMobile("md");

  const maxNum = isMobile ? 10 : 20;
  return (
    <div
      key={donation?.receipt_id}
      className={`row w-100 px-3 px-md-0 m-md-0 gx-0 gx-md-0 border-bottom cursor donation-log-card  `}
      onClick={() => onDonationCardClick(donation)}
    >
      <div className="col-md-12 mx-auto">
        <div className="py-4 flex-grow-1 d-flex flex-wrap align-items-center justify-content-between p-0 text-capitalize border-none">
          {(selectedItems.includes("receipt_id") ||
            selectedItems.includes("payout_id")) && (
            <div className={colClassBuilder}>
              <div className="fs-md fw-medium text-nowrap d-flex align-items-center my-1 me-2">
                <i className="fe-hash fs-base me-1"></i>
                <span className="d-inline-block align-middle text-body">
                  {selectedItems.includes("receipt_id")
                    ? donation?.receipt_id
                    : donation.payout_id}
                </span>
              </div>
            </div>
          )}
          {selectedItems.includes("short_name") && (
            <div className={colClassBuilder}>
              <div className="fs-md fw-medium text-nowrap d-flex align-items-center my-1 me-2">
                <span className="d-inline-block align-middle text-body">
                  {donation?.purpose?.short_name?.length > maxNum
                    ? donation?.purpose?.short_name.slice(0, maxNum) + "..."
                    : donation?.purpose?.short_name}
                </span>
              </div>
            </div>
          )}
          {selectedItems.includes("amount") && (
            <div className={colClassBuilder}>
              <div className="d-flex ">
                <div
                  className=" text-body text-uppercase fs-md my-1 fw-semibold"
                  dir="auto"
                >
                  {formatNumbers(donation?.amount, donation?.currency)}
                </div>
              </div>
            </div>
          )}
          {selectedItems.includes("name") && (
            <div className={colClassBuilder}>
              <div className="d-flex justify-content-md-start">
                <div
                  dir="auto"
                  className="text-nowrap text-body d-flex align-items-center fs-md fw-normal my-1 me-2"
                >
                  {donation?.donor.name.split("*")[0]}

                  <StarsSkeleton stars={donation?.donor.name} max={15} />
                </div>
              </div>
            </div>
          )}
          {selectedItems.includes("email") && (
            <div className={colClassBuilder}>
              <div
                dir="auto"
                className="text-nowrap text-body d-flex align-items-center fs-md fw-normal my-1 me-2 justify-content-start"
              >
                {donation?.donor.email.split("*")[0]}{" "}
                <StarsSkeleton
                  stars={donation?.donor.email.split("@")[0]}
                  max={10}
                />
                {"@"}
                <StarsSkeleton
                  stars={donation?.donor.email.split("@")[1]}
                  max={10}
                />
              </div>
            </div>
          )}
          {selectedItems.includes("received_at") && (
            <div className={colClassBuilder}>
              <div className="text-body flex-1 fs-md fw-medium text-nowrap my-1 me-2 h-100 d-flex justify-content-md-start">
                {dayjs(donation?.received_at).locale("en").format("DD/MM/YYYY")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(DonationDetailsCard);
